import UsersForm from "screens/private/users/form";
export default UsersForm;
